import styles from "./NotFound.module.css";

const NotFound = (props) => {
  return <div>Page not found!</div>;
};

export default NotFound;
